import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const getColumnPlaceholders = ( reportWithPreText, row ) => {
  const descriptionHeaderColumnClassNames = classnames(
    'column', 'col-4', {
      'short-description': reportWithPreText,
    }
  );

  if (row && row.description) {
    return [
      reportWithPreText ? <div key="pretext-column-placeholder" className="column col-1" /> : null,
      <div key="column-placeholder" className={descriptionHeaderColumnClassNames}>
        <div className="underlined-header">{row.description}</div>
      </div>,
    ];
  } else {
    return [
      reportWithPreText ? <div key="pretext-column-placeholder" className="column col-1" /> : null,
      <div key="column-placeholder" className={descriptionHeaderColumnClassNames} />,
    ];
  }
};

const ColumnHeaders = ({ columnNumbers, row, reportWithPreText }) => (
  <div className="column-headers row bold">
    {row.columns && getColumnPlaceholders(reportWithPreText, row).concat(columnNumbers.map(n => (
      <div className="column col-2" key={n}>
        <div className="underlined-header">
          {row.columns[n] ? row.columns[n].value : null}
        </div>
      </div>
    )))}
  </div>
);

ColumnHeaders.propTypes = {
  columnNumbers: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  row: PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.object), // eslint-disable-line react/forbid-prop-types
  }).isRequired,
  reportWithPreText: PropTypes.bool.isRequired,
};

export default ColumnHeaders;
